/**
 * Bind plugin data to the props of a component
 * @param {IAbstractPlugin} plugin - The plugin data that is getting mapped
 * @return {{}} The resulting data object that is being used in a `v-bind` directive
 */
export function bindCmsPluginAttrs({ type, content, ...rest }) { // eslint-disable-line no-unused-vars
    return {
        ...rest,
        ...content,
    };
}
